"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const react_1 = __importStar(require("react"));
const tooltip_portal_1 = require("./components/tooltip-portal");
const hint_icon_1 = require("./icons/hint-icon");
const tooltip_styles_1 = require("./tooltip.styles");
require("./tooltip.types");
const utils_1 = require("./utils");
exports.Tooltip = (0, react_1.memo)((props) => {
    const { to, registerControl } = (0, utils_1.useTooltip)();
    return (react_1.default.createElement(tooltip_styles_1.StyledTooltipBox, null,
        react_1.default.createElement(tooltip_styles_1.StyledHintIcon, Object.assign({}, props),
            react_1.default.createElement(hint_icon_1.HintIcon, Object.assign({}, props, { bg: props.tooltipBgColor, ref: registerControl }))),
        react_1.default.createElement(tooltip_portal_1.TooltipPortal, Object.assign({}, props, { to: to }))));
});
